import Counter from "@/components/Counter";
import { money } from "@/lib/format";

export const priceText = (a) => {
  const ad = Number(a.price_adult) || 0, ke = Number(a.price_keiki) || 0;
  if (!ad && !ke) return a.price_note || "Free";
  const base = ad === ke ? `${money(ad)} per person` : `${money(ad)} adult · ${money(ke)} keiki`;
  return a.price_note ? `${base} (${a.price_note})` : base;
};

export default function ActivityCounts({ activities, value, onChange }) {
  const set = (id, k, v) => onChange({ ...value, [id]: { adults: 0, keiki: 0, ...(value[id] || {}), [k]: v } });
  return (
    <div className="space-y-3">
      <p className="text-lg">Choose how many adults and keiki from your household will go to each activity.</p>
      {activities.map((a) => {
        const s = value[a.id] || {};
        const on = (s.adults || 0) + (s.keiki || 0) > 0;
        return (
          <div key={a.id} data-testid={`activity-row-${a.id}`} className={`rounded-2xl border-2 p-4 sm:p-5 ${on ? "border-[#2B5338] bg-green-50" : "border-[#E6DBCF] bg-white"}`}>
            <p className="font-heading text-xl font-semibold">{a.name}</p>
            <p className="text-stone-700">{priceText(a)}</p>
            {a.description && <p className="text-stone-600 mt-1">{a.description}</p>}
            <div className="flex flex-wrap gap-x-8 gap-y-3 mt-3">
              <Counter label="Adults" testId={`activity-${a.id}-adults`} value={s.adults} onChange={(v) => set(a.id, "adults", v)} />
              <Counter label="Keiki" testId={`activity-${a.id}-keiki`} value={s.keiki} onChange={(v) => set(a.id, "keiki", v)} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
